<template>
  <v-card dense v-bind="$attrs">
    <v-data-table dense :headers="headers" :items="itens" hide-default-footer :server-items-length="total">
      <template v-slot:[colView]="{ item }">
        <v-btn text icon :color="item.selected? 'primary': 'accent'" @click="onView(item)">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>

      <template v-slot:[colinfo]="{ item }">
        {{ item.titulo }} ({{ item.magistrado }})
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import Vue from "vue";

export default Vue.component("tj-table-result", {
  props: {
    itens: Array,
    currentItem: Object
  },

  data() {
    return {
      colinfo: "item.info",
      colView: "item.view",
      headers: [
        { text: "", value: "view"},
        { text: "Assunto", value: "assunto", cellClass: "text-caption", sortable: false },
        { text: "Classe", value: "classe", cellClass: "text-caption", sortable: false },
        { text: "Órgão Julgador/Magistrado", value: "info", cellClass: "text-caption", sortable: false }
      ]
    };
  },

  computed: {
    isCurrent(){
      return (v) => v === this.currentItem
    },

    total(){
      return this.itens? this.itens.length: 0
    }
  },

  methods: {
    onView(item){
      this.current = item;
      this.$emit("view", item)
    }
  }
});
</script>
